export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-zoom-out-c3c2d6e18a5af7083ec454618a729f52.svg";